import { SocketClient } from './SocketClient.ts';
import { CA } from '../analytics/Analytics.ts';
import { versionController } from '../EntryShared.ts';
import { ClientUserState } from '../ClientUserState.ts';
import { SocketSender } from './SocketSender.ts';
import { UIReconnectionController } from '../ui_reconnection/UIReconnectionController.ts';
import { UIDeviceController } from '../ui_html/UIDeviceController.ts';
import { SOCKET_CLOSE_USER_CHANGED } from '@colonist/types';
export class SocketController {
    enableConnect() {
        if (this.enabled) return;
        this.enabled = true;
        ClientUserState.registerChangeListener(()=>{
            this.checkUserChanged();
        });
        this.registerSessionEstablishedObserver(()=>{
            this.checkUserChanged();
        });
    }
    registerSessionEstablishedObserver(callback) {
        this.sessionEstablishedObservers.add(callback);
        return ()=>{
            this.sessionEstablishedObservers.delete(callback);
        };
    }
    handleStateUpdate(state, data) {
        var _this_stateHandlers_get;
        (_this_stateHandlers_get = this.stateHandlers.get(state)) === null || _this_stateHandlers_get === void 0 ? void 0 : _this_stateHandlers_get(data);
    }
    setStateHandler(id, handler) {
        this.stateHandlers.set(id, handler);
    }
    registerSocketCloseObserver(action) {
        this.socketCloseObservers.push(action);
    }
    setSession(newSession) {
        var _CA_logRocket;
        this.session = newSession;
        (_CA_logRocket = CA.logRocket) === null || _CA_logRocket === void 0 ? void 0 : _CA_logRocket.set(this.session);
        versionController === null || versionController === void 0 ? void 0 : versionController.showPatchnotes();
    }
    triggerSessionEstablishedObservers() {
        for (const sessionEstablishedObserver of this.sessionEstablishedObservers){
            sessionEstablishedObserver();
        }
    }
    isSocketOpen() {
        return this.socket.isSocketOpen();
    }
    close(code) {
        if (code != undefined) {
            this.sender.sendCloseSocket(code);
        }
        this.socket.close(code);
    }
    handleSocketClose() {
        this.currentUserId = undefined;
        for (const observer of this.socketCloseObservers){
            observer();
        }
    }
    checkUserChanged() {
        var _ClientUserState_userState;
        if (!this.isSocketOpen() && ClientUserState.hasUser()) {
            this.reconnectionController.startReconnecting();
            return;
        }
        if (((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.id) != this.currentUserId) {
            this.close(SOCKET_CLOSE_USER_CHANGED) // auto reconnect will connect with new user
            ;
        }
    }
    constructor(serverUrl){
        this.enabled = false;
        this.sessionEstablishedObservers = new Set();
        this.stateHandlers = new Map();
        this.socketCloseObservers = [];
        this.reconnectionController = new UIReconnectionController(()=>{
            var _ClientUserState_userState;
            this.currentUserId = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.id;
            return this.socket.connect();
        }, ()=>{
            if (!ClientUserState.hasUser()) return false;
            const isUserOnMobileAppOrWeb = UIDeviceController.isUserOnMobileAppOrWeb();
            if (isUserOnMobileAppOrWeb) return true;
            return document.visibilityState == 'visible';
        }, true);
        this.registerSocketCloseObserver(()=>this.reconnectionController.startReconnecting());
        this.socket = new SocketClient(serverUrl, ()=>this.triggerSessionEstablishedObservers(), (state, data)=>this.handleStateUpdate(state, data), ()=>this.handleSocketClose());
        this.sender = new SocketSender(this.socket, (callback)=>this.registerSessionEstablishedObserver(callback));
    }
}
